import { LibraryStatistics } from '../../types';

export const calculateOverviewStats = (stats: LibraryStatistics) => [
  { 
    title: 'Total Exercises', 
    value: stats.totalExercises,
    trend: { value: 8, isPositive: true }
  },
  { 
    title: 'Equipment Items', 
    value: stats.totalEquipment,
    trend: { value: 3, isPositive: true }
  },
  { 
    title: 'Muscle Groups', 
    value: stats.totalMuscleGroups,
    trend: { value: 2, isPositive: true }
  },
  { 
    title: 'Adaptations', 
    value: stats.totalAdaptations,
    trend: { value: 1, isPositive: true }
  },
];

export const calculateCoverageProgress = (stats: LibraryStatistics) => [
  {
    title: 'Muscle Group Coverage',
    percent: stats.muscleGroupCoverage,
    status: stats.muscleGroupCoverage >= 90 ? 'success' as const : 'normal' as const,
  },
  {
    title: 'Equipment Utilization',
    percent: stats.equipmentUtilization,
    status: stats.equipmentUtilization >= 80 ? 'success' as const : 'normal' as const,
  },
  {
    title: 'Adaptation Coverage',
    percent: stats.adaptationCoverage,
    status: stats.adaptationCoverage >= 80 ? 'success' as const : 'normal' as const,
  },
  {
    title: 'Exercise Variety',
    percent: 76,
    status: 'normal' as const,
  },
];

export const formatTimeRange = (timeRange: string): string => {
  const timeRangeMap: { [key: string]: string } = {
    '7d': 'Last 7 days',
    '30d': 'Last 30 days',
    '90d': 'Last 90 days',
    '1y': 'Last year',
  };
  return timeRangeMap[timeRange] || timeRange;
};

export const calculatePercentageChange = (current: number, previous: number): number => {
  if (previous === 0) return 0;
  return ((current - previous) / previous) * 100;
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const getStatusColor = (status: string): string => {
  const statusColors: { [key: string]: string } = {
    'success': '#52c41a',
    'warning': '#faad14',
    'danger': '#f5222d',
    'info': '#1890ff',
  };
  return statusColors[status] || '#d9d9d9';
};

export const calculateCoverageScore = (covered: number, total: number): number => {
  if (total === 0) return 0;
  return Math.round((covered / total) * 100);
};

export const getCoverageStatus = (percentage: number): 'success' | 'warning' | 'danger' => {
  if (percentage >= 80) return 'success';
  if (percentage >= 60) return 'warning';
  return 'danger';
}; 